import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import ListItem from "./ListItem"

export default function List() {
  const { dataJson } = useStaticQuery(graphql`
    {
      dataJson {
        services {
          paragraphs
          example
          price
          name
          image {
            childImageSharp {
              gatsbyImageData(
                placeholder: BLURRED
                layout: CONSTRAINED
                height: 700
              )
            }
          }
        }
      }
    }
  `)

  return dataJson.services.map((node, index) => (
    <ListItem key={index} node={node} />
  ))
}
